import { render, staticRenderFns } from "./app-role-add.vue?vue&type=template&id=5beb0e0e&scoped=true&"
import script from "./js/app-role-add.js?vue&type=script&lang=js&"
export * from "./js/app-role-add.js?vue&type=script&lang=js&"
import style0 from "./app-role-add.vue?vue&type=style&index=0&id=5beb0e0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb0e0e",
  null
  
)

export default component.exports